"use client";

import React from "react";
import Image from "next/image";
import { twMerge } from "tailwind-merge";

function SvgIcon({ path, className }: { path: string; className?: string }) {
  return (
    <div className={twMerge("w-[20px] h-[20px] relative", className)}>
      <Image
        className={twMerge(
          "w-full h-full absolute top-0 left-0 block",
          className
        )}
        width={128}
        height={128}
        src={path}
        alt="SVG Icon"
      />
    </div>
  );
}

export default SvgIcon;
